import {
  Component,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Inject
} from '@angular/core';

import { NgForm } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { loadStripe, Stripe, StripeCardElement } from '@stripe/stripe-js';

@Component({
    selector: 'app-card-billing',
    templateUrl: './card-billing.component.html',
    styleUrls: ['./card-billing.component.scss'],
    standalone: false
})
export class CardBillingComponent implements  AfterViewInit, OnDestroy {
  @ViewChild('cardInfo', { static: true }) cardInfo: ElementRef;

  loading = false;
  confirmation;

  stripe: Stripe | null = null;
  card: StripeCardElement;
  cardHandler = this.onChange.bind(this);
  error: string;
  totalAmount: any;
  codesCount: any;
  plan: any;
  signup: any;

  constructor(
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CardBillingComponent>) {
      this.totalAmount = this.data.totalAmount;
      this.codesCount = this.data.codesCount;
      this.plan = this.data.plan;
      this.signup = this.data.signup;
    }

   async ngAfterViewInit() {
    this.stripe = await loadStripe('pk_test_zCBCkKgLyMMKTkoFNVCz7MIn');

    if (!this.stripe) {
      console.error('Stripe failed to load.');
      return;
    }

    const elements = this.stripe.elements();
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);

    this.card.on('change', this.cardHandler);
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  ngOnDestroy() {
    if (this.card) {
      this.card.off('change', this.cardHandler);
      this.card.destroy();
    }
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }

  async onSubmit(form: NgForm) {
    if (!this.stripe || !this.card) {
      return;
    }

    const { token, error } = await this.stripe.createToken(this.card);

    if (error) {
      this.error = error.message;
      this.cd.detectChanges();
      return;
    }

    if (this.signup) {
      this.dialogRef.close({ status: 'success', token: token.id });
      this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Payment done successfully',
          type: 'Success',
          message: 'Your payment has been done successfully, thank you!',
          buttonText: 'Ok'
        }
      });
    } else {
      this.stripeTokenHandler(token);
    }
  }

  stripeTokenHandler(token) {
    const signupPayload = {
      Amount: parseInt( this.totalAmount, 10),
      Currency: 'EUR',
      Description: 'Buy ' + this.plan + ' plan',
      Token: token.id,
      Count: parseInt(this.codesCount),
      Type: 2
    };
    const codesPayload = {
      Amount: parseInt( this.totalAmount, 10),
      Currency: 'EUR',
      Description: 'Buy ' + this.codesCount + ' sponsors',
      Token: token.id,
      Count: parseInt(this.codesCount),
      Type: 2
    };
    this.dataService.post('billing/BillingGateway', codesPayload).then((data) => {
      if (data.statusCode === 200) {
        this.dialogRef.close('success');
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Payment done successfully',
            type: 'Success',
            message: 'Your payment has been done successfully, thank you!',
            buttonText: 'Ok'
          }
        });

      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'something went wrong, please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

}
